import { html, TemplateResult } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { WidgetStateFrontEnd } from '../../../../genericDashboard/gzGenericWidget/types';
import { GzGenericWidgetContent } from '../../../../genericDashboard/gzGenericWidget';

/**
 * @summary Type here the description of this component
 * @tag gz-rm-zero-trust-widget
 * Here https://custom-elements-manifest.open-wc.org/analyzer/getting-started/ you can find out how to document the code
 */
@customElement('gz-rm-zero-trust-widget')
export class GzRmZeroTrustWidgetWebComponent extends GzGenericWidgetContent {
  @property({ type: WidgetStateFrontEnd, attribute: true, reflect: true })
  state: WidgetStateFrontEnd;

  @property({ type: Object, attribute: true })
  payload: unknown;

  // see https://lit-element.polymer-project.org/guide/styles
  static get styles() {
    return styles;
  }

  protected renderLoader(): TemplateResult {
    return html` <gz-loader rows="1" columns="1" style="margin-top: calc(var(--spacer) * 4)"></gz-loader>`;
  }

  protected renderContent(): TemplateResult {
    return html` <div>zero trust widget</div>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'gz-rm-zero-trust-widget': GzRmZeroTrustWidgetWebComponent;
  }
}
